<template>
    <div class="base-header">
        <div class="left-wrapper">
            <el-input class="search_box" size="small" v-model="searchValue" placeholder="搜索用户名称">
            </el-input>
            <div class="user_info" @click="goopen">
                <div class="u-f u-ac">
                    <!-- <el-avatar :src="user.avatar"></el-avatar>
                    <span style="margin-left:10px;">{{user.username}}</span> -->
                </div>
                <!-- <div class="u-f">
                    <el-badge :is-dot="is_have_noread" class="item">
                        <el-select v-model="doc_id" placeholder="请选择" size="small" @change="getchanges">
                            <el-option v-for="item in doctor" :key="item.id" :label="item.nickname" :value="item.id">
                                <template>
                                    <div class="u-f">
                                        <div class="nickname">
                                            {{item.nickname}}
                                        </div>

                                        <el-badge class="new_msg_icon" :value="item.no_read" />
                                    </div>
                                </template>
                            </el-option>
                        </el-select>
                    </el-badge>
                </div> -->
            </div>
        </div>
        <div class="right-menu">
            <div class="menu-item" :class="{on:index == curIndex }" v-for="(item,index) in menuList" :key="index"
                @click.stop="selectTab(item)">{{item.title}}</div>
        </div>
        <el-dialog title="设置信息" :visible.sync="dialogVisible" width="30%" :append-to-body="true" center>
            <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
                <el-form-item label="头像" prop="manager_avatar">
                    <el-upload action="/admin/getMediaId" accept="image/*" :limit="1" :file-list="ruleForm.fileList"
                        :on-success='handleSuccess' list-type="picture-card" name="media" :on-remove="uploadRmove">
                        <i class="el-icon-plus"></i>
                    </el-upload>
                </el-form-item>
                <el-form-item label="昵称" prop="manager_name">
                    <el-input v-model="ruleForm.manager_name"></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="submit('ruleForm')" size="small">确 定</el-button>
                <el-button @click="dialogVisible = false" size="small">取 消</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
    import {
        mapState
    } from 'vuex'
    export default {
        name: "baseHeader",
        computed: {},
        data() {
            return {
                doc_id: '',
                doctor: [],
                menuList: [{
                        key: 0,
                        title: '客户信息',
                    },
                    {
                        key: 1,
                        title: '交易订单',
                    },
                    {
                        key: 2,
                        title: '商品信息',
                    },
                ],
                curIndex: 0,
                isOnline: false,

                dialogVisible: false,
                ruleForm: {
                    fileList: [],
                    file_info: [],
                    manager_name: '',
                },
                rules: {
                    manager_name: [{
                        required: true,
                        message: '请填写昵称',
                        trigger: 'blur'
                    }]
                },
                searchValue: '',
                timer: null,
                is_have_noread: false

            }
        },
        computed: {
            ...mapState({
                user: state => state.user.user,
            })
        },
        mounted() {
            let vue = this
            document.addEventListener('click', () => {
                this.isOnline = false
            })
            vue.bus.$on('selectorder', () => {
                this.curIndex=2
                this.bus.$emit('selectRightMenu', this.curIndex)
            })
        },
        watch: {
            'searchValue': {
                handler(value) {
                    if (this.timer) {
                        clearTimeout(this.timer)
                    }
                    this.timer = setTimeout(() => {
                        this.inputChange();
                    }, 1500)
                },
                deep: true
            },
           
        },
        methods: {
            getis_noread(type) {
             this.is_have_noread=this.$openws.is_have_noread
            },
            getchanges() {
                let vue = this
                this.bus.$emit('getdoc', this.doc_id)
                var items = ''
                this.doctor.forEach(item => {
                    if (item.id == this.doc_id) {
                        items = item
                    }

                })
                vue.$parent.usered = items
                vue.$parent.msglist = []
                vue.$parent.to_user = ''
                vue.$parent.user_id = this.doc_id
            },
            selectTab(item) {
                this.curIndex = item.key
                this.bus.$emit('selectRightMenu', this.curIndex)
            },
            setOnline() {
                this.isOnline = !this.isOnline

            },
            changeOnline(type) {
                this.$emit('setOnline', type);
                this.isOnline = false
            },
            // 退出登录
            outLogin() {
                let self = this
                this.$Modal.confirm({
                    title: '退出登录确认',
                    content: '您确定退出登录当前账户吗？打开的标签页和个人设置将会保存。',
                    onOk: () => {
                        self.logoutKefu({
                            confirm: false,
                            vm: self
                        });
                    },
                    onCancel: () => {

                    }
                });
            },
            // 搜索
            bindSearch(e) {
                this.$emit('search', e.target.value);
            },
            // inputChange
            inputChange() {
                this.bus.$emit('change', this.searchValue)
            },
            goopen() {
                // this.dialogVisible=true
            },
            handleSuccess(response, file, fileList) {
                //  this.ruleForm.file_info.push(response.data)
            },
            uploadRmove(file, fileList) {
                var index = this.ruleForm.file_info.findIndex(item => item.id == file.id)
                this.ruleForm.file_info.splice(index, 1)
            },
            submit(formName) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        if (this.ruleForm.file_info.length < 1) return this.$message({
                            type: 'error',
                            message: '请上传头像'
                        });
                        axios.post("/gzh/manager/editManagerInfo", {
                            manager_name: this.ruleForm.manager_name,
                            manager_avatar: this.ruleForm.file_info[0].url,
                        }, {
                            token: true
                        }).then(res => {
                            if (res.data.code == 200) {
                                this.dialogVisible = false
                                this.$message({
                                    type: 'success',
                                    message: '操作成功!'
                                });
                            } else {
                                this.$message({
                                    type: 'error',
                                    message: res.data.msg
                                });
                            }
                        }).catch(err => {})
                    } else {
                        return false;
                    }
                });
            }
        }
    }
</script>

<style lang="scss" scoped>
    .base-header {
        z-index: 99;
        position: relative;
        display: flex;
        align-items: center;
        justify-content: space-between;
        height: 66px;
        padding: 0 0 0 15px;
        background: linear-gradient(270deg, #1890FF 0%, #3875EA 100%);
        color: #fff;
        flex-shrink: 0;

    }

    .left-wrapper {
        position: relative;
        display: flex;
        flex: 1;
        align-items: center;
    }

    .search_box {
        width: 260px;
        border-radius: 17px;
        overflow: hidden;
    }

    .user_info {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-left: 30px;
        cursor: pointer;
        width: 63%;
    }

    .nickname {
        flex: 1;
    }

    .new_msg_icon {
        width: 25%;
    }

    .right-menu {
        display: flex;
        align-items: center;

        .menu-item {
            position: relative;
            margin-right: 30px;
            font-size: 14px;
            font-weight: 400;
            cursor: pointer;

            &.on {
                font-weight: 600;

                &::after {
                    position: absolute;
                    left: 0;
                    bottom: -22px;
                    content: '';
                    width: 100%;
                    height: 2px;
                    background: #fff;
                }
            }
        }
    }
</style>